import React from "react";
import { useTranslation } from "react-i18next";
import ConnectedFundingAccountDrawer from "components/admin/bank/ConnectedFundingAccountDrawer";
import AccountType from "enums/AccountType";
import useGetPersonalBankAccount from "hooks/useGetPersonalBankAccount";
import { CardProgramSummary } from "hooks/useGetBankAccounts";

interface PersonalBankAccountDrawerProps {
  handleCloseDrawer: () => void;
  open: boolean;
  /** The card program the bank repays; it decides which issuer links the bank. */
  program?: CardProgramSummary;
}

const PersonalBankAccountDrawer: React.FC<PersonalBankAccountDrawerProps> = (
  props,
) => {
  const { open, handleCloseDrawer, program } = props;
  const { t } = useTranslation();

  const { bankAccountsArray, loading, refetch } = useGetPersonalBankAccount({
    skip: !open,
    programId: program?.id,
  });

  return (
    <ConnectedFundingAccountDrawer
      open={open}
      handleCloseDrawer={handleCloseDrawer}
      bankAccountsData={bankAccountsArray}
      refetchAccounts={refetch}
      optionalTitle={t("Personal Bank Account")}
      accountType={AccountType.PERSONAL_BANK}
      program={program}
      loadingBankAccountData={loading}
    />
  );
};

export default PersonalBankAccountDrawer;
